/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsKeyValue
 */
export interface MelcoModelsKeyValue {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsKeyValue
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsKeyValue
     */
    value?: string | null;
}

export function MelcoModelsKeyValueFromJSON(json: any): MelcoModelsKeyValue {
    return MelcoModelsKeyValueFromJSONTyped(json, false);
}

export function MelcoModelsKeyValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsKeyValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function MelcoModelsKeyValueToJSON(value?: MelcoModelsKeyValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}


